export const initialState = {
  request: null,
  terms: {},
  termsAcceptances: [],
  termsLoading: false,
  termsError: null,
  acceptTermsLoading: false,
  acceptTermsError: null,
  removeAcceptanceLoading: false,
  removeAcceptanceError: null,
  statusAccept: "",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_GET_TERMS":
      return {
        ...state,
        request: action.payload.request,
        terms: {},
        termsLoading: true,
        termsError: null,
      };
    case "GET_TERMS_SUCCESS":
      return {
        ...state,
        request: null,
        terms: action.payload.terms,
        termsLoading: false,
        termsError: null,
      };
    case "GET_TERMS_ERROR":
      return {
        ...state,
        request: null,
        termsLoading: false,
        termsError: action.error,
      };
    case "REQUEST_LIST_TERMS_ACCEPTANCE":
      return {
        ...state,
        request: action.payload.request,
        termsAcceptances: [],
        termsLoading: true,
        termsError: null,
      };
    case "LIST_TERMS_ACCEPTANCE_SUCCESS":
      return {
        ...state,
        request: null,
        termsAcceptances: action.payload.items,
        termsLoading: false,
        termsError: null,
      };
    case "LIST_TERMS_ACCEPTANCE_ERROR":
      return {
        ...state,
        request: null,
        termsLoading: false,
        termsError: action.error,
      };
    case "REQUEST_ACCEPT_TERMS":
      return {
        ...state,
        request: action.payload.request,
        acceptTermsLoading: true,
        acceptTermsError: null,
        statusAccept: "",
      };
    case "ACCEPT_TERMS_SUCCESS":
      return {
        ...state,
        request: null,
        termsAcceptances: [
          ...state.termsAcceptances,
          action.payload.acceptance,
        ],
        statusAccept: "SUCCESS",
        acceptTermsLoading: false,
        acceptTermsError: null,
      };
    case "ACCEPT_TERMS_ERROR":
      return {
        ...state,
        request: null,
        acceptTermsLoading: false,
        statusAccept: "",
        acceptTermsError: action.error,
      };
    case "REQUEST_REMOVE_TERMS_ACCEPTANCE":
      return {
        ...state,
        request: action.payload.request,
        removeAcceptanceLoading: true,
        removeAcceptanceError: null,
      };
    case "REMOVE_TERMS_ACCEPTANCE_SUCCESS":
      return {
        ...state,
        request: null,
        termsAcceptances: state.termsAcceptances.filter(
          (acceptance) => acceptance.id !== action.payload.acceptance.id
        ),
        removeAcceptanceLoading: false,
        removeAcceptanceError: null,
      };
    case "REMOVE_TERMS_ACCEPTANCE_ERROR":
      return {
        ...state,
        request: null,
        removeAcceptanceLoading: false,
        removeAcceptanceError: action.error,
      };
    case "CLEAR_TERMS_STATUS":
      return {
        ...state,
        statusAccept: "",
      };
    case "CLEAR_TERMS_ERROR":
      return {
        ...state,
        termsError: null,
        acceptTermsError: null,
        removeAcceptanceError: null,
      };
    default:
      return state;
  }
};
